import * as types from './constants';

// Get Shopify Product Types
export const getShopifyProductTypesRequest = data => (
  { type: types.GET_SHOPIFY_PRODUCT_TYPES_REQUEST, payload: data }
);

export const getShopifyProductTypesDone = data => (
  { type: types.GET_SHOPIFY_PRODUCT_TYPES_DONE, payload: data }
);

export const getShopifyProductTypesFailed = errors => (
  { type: types.GET_SHOPIFY_PRODUCT_TYPES_FAILED, payload: errors }
);

export const getShopifyProductTypesReset = () => (
  { type: types.GET_SHOPIFY_PRODUCT_TYPES_RESET }
);

// Operations
export const shopifyProductTypesSetPage = data => (
  { type: types.SHOPIFY_PRODUCT_TYPES_SET_PAGE, payload: data }
);
